export enum DeviceType {
  Nvr = 0,
  Camera = 1,
  Sensor = 2,
  ExternalService = 3,
  Vms = 4,
  Relay = 5,
  Speaker = 6,
}

export const integrationTypeNames = {
  Nvr: 'NVR',
  Camera: 'Camera',
  Sensor: 'Sensor',
  ExternalService: 'External Service',
  Vms: 'VMS',
  Relay: 'Relay',
  Speaker: 'Speaker',
};

export enum SourceType {
  Graph = 0,
  Code = 1,
}

export type IntegrationField = {
  id: string;
  name: string;
  dataType: string;
  description?: string;
  documentation?: string;
  options?: string[] | null;
  multiple?: boolean;
  optional?: boolean;
};

export type PartialIntegrationFieldDto = {
  id?: string;
  name: string;
  dataType: string;
  description?: string;
  documentation?: string;
  options?: string[] | null;
  multiple?: boolean;
  optional?: boolean;
};

export type IntegrationLimitedDto = {
  id: string;
  key?: string | null;
  name: string;
  integrationType: keyof typeof integrationTypeNames;
  sourceType: SourceType;
  brand?: string;
  docs?: string;
  description?: string;

  integrationFields: IntegrationField[];

  smtpSource: boolean;
  webhookSource: boolean;
  watchfulLifecycleTrigger: boolean;

  created: string;
  updated: string;
};

export type IntegrationFullDto = IntegrationLimitedDto & {
  sourceCode: string;
  compiledCode: string;
  syncedCompiledCode?: string | null;
  syncedVersion?: string | null;
};

export enum IntegrationLogLevel {
  Debug = 'Debug',
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error',
}

export interface IntegrationScriptLogDto {
  message: string;
  timestamp: string;
  level: IntegrationLogLevel;
}

export interface SubCameraDto {
  id: string;
  model: string;
  name: string;
  vendor: string;
  videoProcessorId: UniqueVideoProcessorId;
  externalId: string;
  quillNotes?: string;
  description?: string;
  activationWkt?: string;
  datalayerVpc?: string;

  capabilities: {
    canTalkdown?: boolean;
    canLivestream?: boolean;
    canPlayback?: boolean;
    canGetTriggerSettings?: boolean;
    canSetTriggerSettings?: boolean;
  };
}

export interface NVRDto {
  id: string;
  description: string;
  externalId: string;
  name: string;
}

export interface RelayDto {
  id: string;
  name: string;
  componentGroupId?: string;
  relatedComponentGroups?: string[];
  enabled?: boolean;
}

export interface SpeakerDto {
  id: string;
  componentGroupId: string;
  name: string;
  relatedComponentGroups?: string[];
  enabled?: boolean;
}

export interface UniqueVideoProcessorId {
  value: string;
  deviceId: string;
}
